import { render, staticRenderFns } from "./control-left.vue?vue&type=template&id=37d49e5c&scoped=true&"
import script from "./control-left.vue?vue&type=script&lang=tsx&"
export * from "./control-left.vue?vue&type=script&lang=tsx&"
import style0 from "./control-left.vue?vue&type=style&index=0&id=37d49e5c&prod&lang=scss&scoped=true&"
import style1 from "./control-left.vue?vue&type=style&index=1&id=37d49e5c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d49e5c",
  null
  
)

export default component.exports